import app from "@/main";
import {Mixins} from "../Mixins";
import Vekil from "./Vekil";
import TemelBilgileri from "./TemelBilgileri";
import HesapBilgisi from "./HesapBilgisi";
import Adres from "./Adres";
import TakipRolleri from "./TakipRolleri";
import {HashArguments} from "./HashArguments";
import TarafInterface from "./TarafInterface";
import {DosyaFormDataInterface} from "../DosyaFormDataInterface";
import {MtsDosyaFormData} from "../MtsDosyaFormData";
import {AdresTuru} from "@/plugins/uyap-plugin/enum/uyap/AdresTuru";
import {durdurucuHataMi} from "../../utils/tebligatTalepUtils";
import {mersisAdresiBulunduMu} from "../../uyap/GetKurumMersisAdresi";

function adresDolu(adres: Adres | undefined): boolean {
    return !!adres && String(adres.adres || "").trim() != "";
}

export default class TarafKurum extends TarafInterface {
    constructor(isMts = false) {
        super();
        this.isMts = isMts;
    }

    async parse(
        tarafDomNode: Element,
        vekilList: Vekil[],
        formData: DosyaFormDataInterface | MtsDosyaFormData,
    ) {
        let kisiKurumBilgileriDomNode = tarafDomNode.querySelector('kisiKurumBilgileri');
        //@ts-ignore
        let kisiTumBilgileriDomNode = kisiKurumBilgileriDomNode.querySelector('kisitumbilgileri');
        //@ts-ignore
        let adresDomNode = kisiKurumBilgileriDomNode.querySelector("adres");
        //@ts-ignore
        let kurumDomNode = kisiKurumBilgileriDomNode.querySelector('kurum');
        this.kurumMu = true;
        this.tarafTuru = "KURUM";
        //@ts-ignore
        let rolID = tarafDomNode.querySelector('roltur').getAttribute("rolid");
        this.formData = formData;
        let tarafSifati = new TakipRolleri().find(rolID);
        if (tarafSifati)
            this.tarafSifati = tarafSifati;
        if (this.isMts && tarafSifati) {
            this.rolGirisBilgisi = tarafSifati;
            if (this.isAlacakli()) {
                this.alacakliIletisimEPosta = formData.alacakliEposta;
                this.alacakliIletisimTelefon = formData.alacakliTelefon;
            }
        }
        if (kurumDomNode) {
            this.kurumAdi = Mixins.nullUndefCleaner(kurumDomNode.getAttribute("kurumadi"));
            this.mersisNo = Mixins.nullUndefCleaner(kurumDomNode.getAttribute("mersisno"));
            this.vergiNo = Mixins.nullUndefCleaner(kurumDomNode.getAttribute("vergino"));
            this.detsisNo = Mixins.nullUndefCleaner(kurumDomNode.getAttribute("detsisno"));
            this.hesapBilgisi = new HesapBilgisi(tarafDomNode);
            this.refId = Mixins.nullUndefCleaner(tarafDomNode.getAttribute("id"));
            //@ts-ignore
            this.adresBilgisi = await Adres.parse(adresDomNode, this.isMts);
            this.adresBilgisi.kaynak = "xml";
            this.adresList.push(this.adresBilgisi);
            this.temelBilgileri = TemelBilgileri.parse(kurumDomNode);
        }
        this.setAlacakliMernisAdresiTercihi(formData.alacakliMernisAdresiKullan);
        this.setMernisAdresiTercihi(formData.mernisAdresiKullan);
        this.setVekil(tarafDomNode, vekilList);
        this.setTarafHashList();
        return this;
    }

    setTarafHashList() {
        let hashArguments = HashArguments.kurum();
        hashArguments.rolId = this.tarafSifati.rolID.toString();
        hashArguments.vergino = this.temelBilgileri.vergiNo;
        hashArguments.mersisno = this.temelBilgileri.mersisNo;
        hashArguments.kurumadi = this.temelBilgileri.kurumAdi;
        if ((this.isMts && this.tarafSifati.rolID == 21) || !this.isMts)
            this.tarafHashList.push(hashArguments);
    }

    async runQuery(mtsAlacakliTaraf: any = null): Promise<void> {
        try {
            this.addMessage('info', 'Borçlu kurum sorgulanıyor!');
            await this.borcluKurumSorgula(mtsAlacakliTaraf);
            this.addMessage('success', 'Borçlu kurum sorgulama yapıldı!');
            try{
                await this.setVekilListesi();
                this.addMessage('success', 'Borçlu vekil listesi eklendi !');
            }catch (e) {
                this.addMessage('error', 'Borçlu vekil bulunamadı !');
            }
            console.log("Taraf Kurum runQuery Bitti", this)
            return ;
        } catch (e) {
            // DEV-3879: MTS'de durdurma/oturum hatası satırı durdurur; yutulursa satır başarılı bitip tevziye geçebilir.
            if (this.isMts && durdurucuHataMi(e))
                throw e;
            // @ts-ignore
            this.addMessage('error', 'Taraf kurum sorgulama hatası: ' + e.message);
            // Hata durumunda bile process devam etsin, borçlu listede görünsün
            // throw new Error(e.message); // Bu satırı kaldırarak borçlunun listede görünmesini sağlıyoruz
        }
    }

    async borcluKurumSorgula(mtsAlacakliTaraf: any): Promise<void> {
        try {
            const xmldeDetsisVar = String(this.detsisNo || "").trim() !== "";
            const xmldeMersisYok = String(this.mersisNo || "").trim() === "";
            const xmldeVergiYok = String(this.vergiNo || "").trim() === "";
            // Yalnızca DETSİS no varken (mersis ve vergi yokken) sorguya sadece DETSİS no gönderilir.
            const sadeceDetsisVar = xmldeDetsisVar && xmldeMersisYok && xmldeVergiYok;
            let kurum;
            if (sadeceDetsisVar) {
                // Kurum adı/mersis/vergi birlikte gönderildiğinde UYAP PRTL_GNL_1-1 ("kurum adı ile
                // vergi numarası eşleşmiyor") hatası dönebildiği için yalnızca DETSİS no gönderilir.
                kurum = await app.$uyap.KurumSorgulama().run({
                    mersisNo: "",
                    kurumAdi: "",
                    vergiNo: "",
                    detsisNo: this.detsisNo,
                });
            } else {
                kurum = await app.$uyap.KurumSorgulama().recursive({
                    mersisNo: this.mersisNo,
                    kurumAdi: this.kurumAdi,
                    vergiNo: this.vergiNo,
                    detsisNo: this.detsisNo,
                });
            }
            this.addMessage('success', 'Kurum Bulundu!');

            let secilen = kurum[0];
            await this.setTarafKurum(secilen, mtsAlacakliTaraf);
        } catch (e) {
            if (this.isMts && durdurucuHataMi(e))
                throw e;
            // @ts-ignore
            this.addMessage('error', 'Kurum sorgulama hatası: ' + e.message);
            // Kurum bulunamadığında temelBilgileri'ne hata mesajı ekle
            if (!this.temelBilgileri.kurumAdi || this.temelBilgileri.kurumAdi.trim() === '') {
                // @ts-ignore
                this.temelBilgileri.kurumAdi = "⚠️ HATA: " + e.message;
            }
            // Hata durumunda bile taraf bilgilerini set et (borçlu listede görünsün)
            await this.setTarafKurum(null, mtsAlacakliTaraf);
            // Hata fırlatma, borçlu listede görünmeye devam etsin
            // throw new Error(e.message); // Bu satırı kaldırarak borçlunun listede görünmesini sağlıyoruz
        }
    }

    async setTarafKurum(kurumBilgileri: any, mtsAlacakliTaraf: any): Promise<void> {
        try {
            if (this.isMts) {
                this.temelBilgileri.sorguTuru = 2;
                if (kurumBilgileri != null) {
                    this.temelBilgileri = kurumBilgileri; //UYAP update 20/09/2019
                    if (mtsAlacakliTaraf != null) {
                        if (mtsAlacakliTaraf.vergiNo == kurumBilgileri.vergiNo) {
                            this.temelBilgileri = mtsAlacakliTaraf;
                        }
                    }
                    this.temelBilgileri.sorguTuru = 0; //0 diye hatirliyorum bak 15.10.2019
                }
                await this.runQueryForMtsAdresList();
            } else {
                this.sorguTuru = 2;
                if (kurumBilgileri != null) {
                    this.temelBilgileri = kurumBilgileri; //UYAP update 20/09/2019
                    this.sorguTuru = 0;
                }
                await this.runQueryForAdresList();
            }

            this.addMessage('success', 'Adres listesi alındı!')
            if (this.isAlacakli()) {
                await this.runQueryForHesapBilgisi();
                this.addMessage('success', 'IBAN listesi alındı!')
            }
        } catch (e) {
            console.error("ERROR SET TARAF KURUM", e);
            if (this.isMts && durdurucuHataMi(e))
                throw e;
            //@ts-ignore
            throw new Error(e.message);
        }
    }

    setAdresBilgisi(adresBilgisi: Adres) {
        // DEV-3879: Boş adres gelirse eldeki adres (ör. XML'deki) ezilmesin.
        if (!adresBilgisi)
            return;
        this.adresBilgisi = adresBilgisi;
        if (this.isMts)
            this.adresBilgisi.kisiKurumID = this.temelBilgileri.kisiKurumId;
    }


    async runQueryForMtsAdresList(): Promise<void> {
        try {
            if (typeof this.temelBilgileri.kisiKurumID != "undefined") {
                this.temelBilgileri.kisiKurumId = this.temelBilgileri.kisiKurumID;
            }else{
                throw new Error(this.temelBilgileri.adi + " " + this.temelBilgileri.soyadi + " - Borçlu sorgulama başarısız ! Lütfen XML'inizdeki borçlu bilgisini kontrol ediniz.")
            }
            //TODO burada zorunlu olmasi lazim kisiKurumID
            let adresList: Adres[] = [];
            try {
                adresList = await app.$uyap.GetAdresList().run(
                    {
                        kisiKurumId: this.temelBilgileri.kisiKurumId,
                        tarafTur: 2
                    });
            } catch (e) {
                if (durdurucuHataMi(e))
                    throw e;
                console.log("MTS ADRES LISTESI ALINAMADI", e);
            }
            if (!Array.isArray(adresList))
                adresList = [];
            // Sorgu yeniden çalıştırılınca UYAP adresleri listede çoğalmasın.
            this.adresList = this.adresList.filter(adres => adres.kaynak != "uyap");
            if (this.adresList.indexOf(this.adresBilgisi) < 0 && this.adresList.length > 0)
                this.adresBilgisi = this.adresList[0];
            adresList.forEach(adres => adres.kaynak = "uyap");
            this.adresList = this.adresList.concat(adresList);
            let mersisAdresi = adresList.find((adres: Adres) => adres.adresTuruAciklama == "Mersis Adresi" && adresDolu(adres));
            let yurticiIkametAdresi = adresList.find((adres: Adres) => adres.adresTuruAciklama == "Yurt İçi İşyeri Adresi" && adresDolu(adres));

            if (this.isBorclu() && this.formData.mernisAdresiKullan === true) {
                // DEV-3879: UYAP kurum sorgusu artık merkezAdresi döndürmüyor; şirket borçlunun
                // mersis adresi İcra Takibi'ndeki gibi UYAP adres listesinden, listede yoksa
                // UYAP mersis sorgusundan alınır. İkisi de yoksa İşyeri, o da yoksa XML adresi kalır.
                if (!mersisAdresi)
                    mersisAdresi = await this.getKurumMersisAdresi();
                if (mersisAdresi) {
                    mersisAdresi.adresTuru = "ADRTR00011 "; //Boşluktan hata veriyor EUP - 449 hatası
                    this.setAdresBilgisi(mersisAdresi);
                } else if (yurticiIkametAdresi) {
                    this.setAdresBilgisi(yurticiIkametAdresi);
                } else if (!adresDolu(this.adresBilgisi)) {
                    // XML'de adres yoksa listedeki dolu bir adres kullanılır.
                    let doluAdres = this.adresList.find(a => a.adresTuru != AdresTuru.ELEKTRONIK_TEBLIGAT && adresDolu(a));
                    if (doluAdres)
                        this.setAdresBilgisi(doluAdres);
                }
            } else {
                if (mersisAdresi)
                    mersisAdresi.adresTuru = "ADRTR00011 "; //Boşluktan hata veriyor EUP - 449 hatası
                // DO eup - 457
                if (this.formData.alacakliMernisAdresiKullan && mersisAdresi) {
                    this.setAdresBilgisi(mersisAdresi);
                } else if (!this.formData.alacakliMernisAdresiKullan && yurticiIkametAdresi) {
                    this.setAdresBilgisi(yurticiIkametAdresi);
                } else {
                    let cleverAdres = this.adresList.find(a=>a.adresTuru != AdresTuru.ELEKTRONIK_TEBLIGAT && adresDolu(a));//Etebligat adresi olunca hata geliyor
                    if(cleverAdres){
                        this.setAdresBilgisi(cleverAdres);
                    }else{
                        if(this.temelBilgileri?.merkezAdresi){
                            this.setAdresBilgisi(this.temelBilgileri.merkezAdresi);
                        }else{
                            this.setAdresBilgisi(this.adresBilgisi);
                        }
                    }
                }
            }
            // Önizleme seçili adresi adresListPickedIndex'ten gösteriyor; UYAP'a gidecek adresle eşitle.
            this.adresListPickedIndex = this.adresList.indexOf(this.adresBilgisi);
            if (this.adresListPickedIndex < 0)
                this.adresListPickedIndex = 0;
        } catch (e) {
            if (durdurucuHataMi(e))
                throw e;
            console.log("MTS ADRES HATA", e);
        }
    }

    async getKurumMersisAdresi(): Promise<Adres | undefined> {
        let mersisNo = String(this.temelBilgileri.mersisNo || this.mersisNo || "").trim();
        if (mersisNo == "")
            return undefined;
        try {
            let mersisIstegi = app.$uyap.GetKurumMersisAdresi();
            // Sınıf evrak formları için beklemesiz; toplu MTS sorgusunda UYAP istekleri
            // arasındaki 2 sn bekleme (DEV-3572) bu istekte de geçerli olsun.
            mersisIstegi.delayTime = 2000;
            let cevap = await mersisIstegi.run({
                mersisNo: mersisNo,
                vergiNo: this.temelBilgileri.vergiNo || this.vergiNo
            });
            if (!mersisAdresiBulunduMu(cevap))
                return undefined;
            let mersisAdresi = new Adres();
            mersisAdresi.ilKodu = cevap.ilKodu != null ? String(cevap.ilKodu) : "";
            mersisAdresi.ilAdi = cevap.ilAdi || "";
            mersisAdresi.ilceKodu = cevap.ilceKodu != null ? String(cevap.ilceKodu) : "";
            mersisAdresi.ilceAdi = cevap.ilceAdi || "";
            mersisAdresi.adres = cevap.adres;
            mersisAdresi.adresTuru = AdresTuru.MERSIS;
            mersisAdresi.adresTuruAciklama = "Mersis Adresi";
            mersisAdresi.kaynak = "uyap";
            this.adresList.push(mersisAdresi);
            return mersisAdresi;
        } catch (e) {
            if (durdurucuHataMi(e))
                throw e;
            console.log("KURUM MERSIS ADRESI ALINAMADI", e);
            return undefined;
        }
    }

    runQueryForAdresList(): Promise<void> {
        return new Promise(async (resolve, reject) => {
            if (
                typeof this.temelBilgileri.kisiKurumID != "undefined" &&
                this.temelBilgileri.kisiKurumID > 0
            ) {
                try {

                    let adresList = await app.$uyap.GetAdresList().run(
                        {
                            kisiKurumId: this.temelBilgileri.kisiKurumID,
                            tarafTur: 2
                        });
                    if (adresList.length > 0) {
                        adresList.map(v=> v.kaynak="uyap");
                        this.adresList = this.adresList.concat(adresList);
                    }
                    // Alacaklı da olsa, borçlu da olsa, öncelikle dönen adresi seç.
                    // Dönen adres hiç yoksa xml'deki adresi tercih et. Ama tüm adresler seçenek olarak eklensin.

                    let mersisAdresi = adresList.find(a => a.adresTuruAciklama == "Mersis Adresi");
                    let yurticiIsyeriAdresi = adresList.find(a => a.adresTuruAciklama == "Yurt İçi İşyeri Adresi");
                    console.log("mersisAdresi", mersisAdresi);
                    console.log("yurticiIsyeriAdresi", yurticiIsyeriAdresi);
                    if ((this.isBorclu() && this.getMernisAdresTercihi() == true) || (this.isAlacakli() && this.getAlacakliMernisAdresTercihi() == true)) {
                        console.log("Uyap'tan gelen adreslerin en maktıklısını seç")
                        if (mersisAdresi) {
                            console.log("Mersis Adresini Seçtim", mersisAdresi);
                            this.adresBilgisi = mersisAdresi;
                        } else if (yurticiIsyeriAdresi) {
                            this.adresBilgisi = yurticiIsyeriAdresi;
                            console.log("yurticiIsyeriAdresi Seçtim", yurticiIsyeriAdresi);
                        }
                    }
                    this.mernisAdresiKullan = false;//True olduğunda hata veriyor * emre
                    this.adresListPickedIndex = this.adresList.indexOf(this.adresBilgisi);
                    if (this.adresListPickedIndex < 0)
                        this.adresListPickedIndex = 0;
                    //xmldeki adresi bazen bulamiyor.
                    return resolve();
                } catch (e) {
                    console.log("ADRES YOK XMLDEKINI KULLAN ", e);
                    this.adresListPickedIndex = 0;
                    return resolve();
                }
            } else {
                return reject({message: "Taraf Kurum Bulunamadı !!"});
            }
        })
    }

}

